// removed by extract-text-webpack-plugin
module.exports = {"stories":"dh-metoo-stortinget-stories","story":"dh-metoo-stortinget-story"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stories/index.css
// module id = 17
// module chunks = 0